export interface FetchedTierType {
  currency?: string;
  level: number;
  name: string;
  prize: number;
  state: string;
  targetTime?: number;
  previousPrice?: number;
}

export enum JackpotProviders {
  RedTiger = 'redtiger',
  BluePrint = 'blueprint',
}

export interface JackpotTile {
  provider: JackpotProviders;
  logo: {
    source?: string;
    alt?: string;
  };
  background: {
    normal?: string;
    won?: string;
  };
  code: string;
  fields: {
    title?: string;
    code: string;
    messages?: {
      active?: string;
    };
  }[];
  staticTexts: {
    winMessage: string;
    nextJackpot: string;
    time: {
      hours: string;
      minutes: string;
      seconds: string;
    };
  };
}

export interface ExpectedTierType {
  name: string;
  state: 'normal' | 'active' | 'won';
  curValue: number;
  releaseTime?: string;
  releaseMessage?: string;
  previousPrice?: number;
}

interface OverlayTier {
  name: string;
  value: number;
  message?: string;
  nextValue: number;
  nextJackpotName: string;
  background: {
    source: {
      normal: string;
      retina?: string;
      modern?: {
        normal: string;
        retina?: string;
      };
    };
  };
}

export interface JackpotSlotMapped {
  type: 'vegas-millions' | 'red-tiger';
  images: {
    logo: {
      source: {
        normal: string;
        retina?: string;
        modern?: {
          normal: string;
          retina?: string;
        };
      };
      alt: string;
    };
    background: {
      source: {
        normal: string;
        retina?: string;
        modern?: {
          normal: string;
          retina?: string;
        };
      };
    };
  };
  staticTexts: {
    winMessage: string;
    nextJackpot: string;
    time: {
      hours: string;
      minutes: string;
      seconds: string;
    };
  };
  tiers: ExpectedTierType[];
  overlayTier?: OverlayTier;
  locale?: string;
  currencyCode?: string;
  timestamp: number;
}

export interface FetchJackpotsV2DataParams {
  currency?: string;
  gamesJackpotCodes: string[];
  provider: string;
}

export enum JackpotsV2StateValues {
  ACTIVE = 'ACTIVE',
  NORMAL = 'NORMAL',
  WON = 'WON',
}

export enum GamesGlobalJackpotV2Values {
  MEGA = 'MEGA',
  MAJOR = 'MAJOR',
  MINOR = 'MINOR',
  MINI = 'MINI',
}

export interface JackpotV2DataInterface {
  code: string;
  currency: string;
  timestamp: string;
}

export interface JackpotV2ValueInterface {
  dropFrom?: string;
  previousPrice?: number;
  price: number;
  state: JackpotsV2StateValues;
  targetTime?: string;
  updateInterval?: number;
}

export interface SingleJackpotV2Interface extends JackpotV2DataInterface {
  value: JackpotV2ValueInterface;
}

export interface MultipleJackpotV2Interface extends JackpotV2DataInterface {
  values: Record<string, JackpotV2ValueInterface>;
}

export type JackpotsV2ResponseType = Record<
  string,
  SingleJackpotV2Interface | MultipleJackpotV2Interface
>;
